import React from 'react';
import { connect } from 'react-redux';
import { SectionComponent } from 'Features/MyAccount/SectionComponent';

export const MvpdSubscriptionComponent = ({ mvpdId, withMvpds }) => {
  const mvpd = withMvpds.find((mvpd) => mvpd.mvpdId === mvpdId);

  if (mvpd) {
    return (
      <SectionComponent
        subTitle="Manage Subscription"
        sectionRight={
          <div className="mvpdSubscriptionSection" data-testid="mvpdSubscription">
            <img className="titleLogo" src={mvpd.imageSrc} width="175" height="87.5" alt={mvpd.name} />
            <div className="manageCopy">You can manage your Fox Nation Subscription on your TV Provider's website.</div>
          </div>
        }
      />
    );
  }
  return null;
};

const mapStateToProps = ({
  appConfig: {
    strings: { withMvpds },
  },
}) => ({
  withMvpds,
});
export const MvpdSubscription = connect(mapStateToProps)(MvpdSubscriptionComponent);
